function accordionContent() {
  $(".accordion-header").on("click", function () {
    const parentAccordion = $(this).closest(".accordion");
    if (parentAccordion === undefined) {
      return;
    }

    parentAccordion.toggleClass("active");

    const content = parentAccordion.find(".accordion-content");
    if (content === undefined) {
      return;
    }

    if (parentAccordion.hasClass("active")) {
      content.slideDown();
    } else {
      content.slideUp();
    }
  });
}

function legacyAccordionContent() {
  $(".plan-accordion-section .inner-list .item").find(".heading-section .arrow-wrapper").append('<i class="fas fa-caret-down"></i>');
  $("body").on("click", ".plan-accordion-section .inner-list .item", function () {
    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $(this).find(".content-wrapper").removeClass("active");
      $this.find(".heading-section .arrow-wrapper ").empty().append('<i class="fas fa-caret-down"></i>');
    } else {
      $this.addClass("active");
      $(this).find(".content-wrapper").addClass("active");
      $this.find(".heading-section .arrow-wrapper ").empty().append('<i class="fas fa-caret-up"></i>');
      // $(this).find( '.content-wrapper' ).toggleClass( 'active' );
    }
  });
  // $('.plan-accordion-section .inner-list .item').find( '.heading-section .arrow-wrapper' ).append( '<i class="fas fa-caret-down"></i>' );
  $(".important-stuff-section .inner-list >.item").find(".inner-heading >.arrow-wrapper").append('<i class="fas fa-caret-down"></i>');
  $(".important-stuff-section .inner-list.is-active-first > .item")
    .eq(0)
    .addClass("active")
    .find(">.inner-contents")
    .addClass("is-active")
    .slideDown()
    .find(">.inner-heading .arrow-wrapper")
    .empty()
    .append('<i class="fas fa-caret-up"></i>');
  $("body").on("click", ".important-stuff-section .inner-list .item .inner-heading", function (e) {
    // alert();
    e.stopPropagation();

    var $this = $(this).parent(".item");
    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $this.find(">.inner-contents").removeClass("is-active");
      $this.find(">.inner-contents").slideUp();
      $this.find(">.inner-heading .arrow-wrapper ").empty().append('<i class="fas fa-caret-down"></i>');
    } else {
      $this.addClass("active");
      $this.find(">.inner-contents").addClass("is-active");
      $this.find(">.inner-contents").slideDown();
      $this.find(">.inner-heading .arrow-wrapper ").empty().append('<i class="fas fa-caret-up"></i>');
      // $(this).find( '.content-wrapper' ).toggleClass( 'active' );
    }
  });

  $("body").on("click", ".accordion-items .item", function (e) {
    e.stopPropagation();

    var $this = $(this);
    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $this.find(">.inner-contents").removeClass("is-active");
      $this.find(">.inner-contents").slideUp();
      $this.find(">.inner-heading .arrow-wrapper ").empty().append('<i class="fas fa-caret-down"></i>');
    } else {
      $this.addClass("active");
      $this.find(">.inner-contents").addClass("is-active");
      $this.find(">.inner-contents").slideDown();
      $this.find(">.inner-heading .arrow-wrapper ").empty().append('<i class="fas fa-caret-up"></i>');
    }
  });
}

function plansHeight() {
  // var promotionmaxHeight = 0;
  // $(".services-plans .plans .list .plan .promotion, .travel-sim-plans .plans .list .plan .promotion").each(function(){
  //     if ($(this).outerHeight() > promotionmaxHeight) { promotionmaxHeight = $(this).outerHeight(); }
  // });

  var subheadmaxHeight = 0;
  $(".services-plans .plans .list .plan .suitable_for_nbn, .travel-sim-plans .plans .list .plan .subhead").each(function () {
    if ($(this).outerHeight() > subheadmaxHeight) {
      subheadmaxHeight = $(this).outerHeight();
    }
  });

  if (window.matchMedia("(min-width: 1024px)").matches) {
    // $(".services-plans .plans .list .plan, .travel-sim-plans .plans .list .plan").not('.special,.limited').css('margin-top', promotionmaxHeight);
    $(".services-plans .plans .list .plan .suitable_for_nbn, .travel-sim-plans .plans .list .plan .subhead").css("height", subheadmaxHeight);
  } else {
    $(".services-plans .plans .list .plan, .travel-sim-plans .plans .list .plan").not(".special,.limited").css("margin-top", 0);
    $(".services-plans .plans .list .plan .suitable_for_nbn, .travel-sim-plans .plans .list .plan .subhead").css("height", "auto");
  }
}

function copyToClipboard(element) {
  var $temp = $("<input>");
  $(element).append($temp);
  $temp.val($(element).text()).select();
  $temp.focus();
  document.execCommand("copy");
  $temp.remove();

  alert("Copied to clipboard!");
}

function submenuMobile() {
  $(".has-child-menu").append('<i class="fas fa-caret-right"></i>');
  $(".has-child-menu > i").on("click", function () {
    var $this = $(this);
    if ($this.parent().hasClass("menu-active")) {
      $this.parent().removeClass("menu-active");
      $(this).removeClass("fa-caret-down").addClass("fa-caret-right");
    } else {
      $this.parent().addClass("menu-active");
      $(this).removeClass("fa-caret-right").addClass("fa-caret-down");
    }
  });
}

function checkAddress() {
  // $(".popup-contents-wrapper .address").on("click", function() {
  //     // alert();
  //     if ($(this).is(':focus')) {
  //         // $(this).on("click", toggle);
  //         $('#banner-homemodal').modal("show");
  //     }
  // });
}

/* SCROLL TO SECTION */
$(document).on("click", 'a[href^="#"]', function (event) {
  event.preventDefault();

  const hrefSelector = $(this).attr("href");

  if (hrefSelector.length < 2) {
    return;
  }

  const offsetTop = 60;
  const easingMs = 200;

  $("html, body").animate(
    {
      scrollTop: $(hrefSelector).offset().top - offsetTop,
    },
    easingMs
  );
});

function reviewTabs() {
  $(".tab-heading-wrapper .item a").each(function () {
    var $this = $(this);
    $this.on("click", function () {
      $(".tab-heading-wrapper .item a").removeClass("btn-green");
      $(".tab-heading-wrapper .item a").addClass("btn-yellow");

      $(this).removeClass("btn-yellow");
      $(this).addClass("btn-green");

      var tagid = $(this).data("tabcontent");
      $(".tab-wrapper-content .fa-spinner").fadeIn();

      $(".item-content").removeClass("active").addClass("hide");
      setTimeout(function () {
        $("#" + tagid)
          .addClass("active")
          .removeClass("hide");
        $(".tab-wrapper-content .fa-spinner").fadeOut();
        window.__productReviewCallbackQueue = window.__productReviewCallbackQueue || [];
        window.__productReviewCallbackQueue.push(function (ProductReview) {
          ProductReview.use("reviews-vertical", {
            identificationDetails: {
              type: "single",
              strategy: "from-internal-entry-id",
              identifier: "da1f24e1-1b75-496f-8916-f06d2612b2c6",
            },
            container: "#pr-reviews-vertical-widget",
          });
        });
      }, 1000);
    });
  });
}

// On Load
$(window).on("load", function () {
  plansHeight();
  submenuMobile();
  reviewTabs();
  // checkAddress();

  /*STOP PRELOADING*/
  $("body").removeClass("preload");
});

$(document).ready(function () {
  // parrallaxBanner();
  accordionContent();
  legacyAccordionContent();

  // $('[data-bs-toggle="tooltip"]').tooltip();
  $('[data-bs-toggle="popover"]').popover();
  $(".popover-dismiss").popover({
    trigger: "focus",
  });
  // plansHeight();

  // On Resize
  $(window).on("resize", function (e) {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
      // add your codes here
      plansHeight();
      // end
    }, 350);
  });

  /** Header
   * ===================================== */
  $(".marquee").marquee({
    duration: 5000,
    gap: 100,
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    startVisible: true,
  });

  /** Mobile Menu
   * ===================================== */
    $(".mobile-menu-toggle").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);
        var $mobile_menu = $(".mobile-menu");
        if ($this.hasClass("is-active")) {
            $this.removeClass("is-active");
            $mobile_menu.removeClass("active");
            $("body").css("overflow", "visible");
        } else {
            $this.addClass("is-active");
            $mobile_menu.addClass("active");
            $("body").css("overflow", "hidden");
        }
    });

  /** GFROM
   * ===================================== */
  $("body").on("click", ".math-captcha .q", function () {
    $(this).parent().find("input").eq(0).focus();
  });

  /** Slider options
   * ===================================== */
  // Latest From Your Mates Slider
  // $(".latest-from-your-mates .owl-carousel").owlCarousel({
  //   loop: true,
  //   margin: 10,
  //   dotsContainer: ".pagination-from-your-mates",
  //   nav: false,
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //   },
  // });

  // var fyis = $(".find-your-internet-section .owl-carousel");
  // fyis.on("initialized.owl.carousel", function (event) {
  //   // console.log('test');
  //   // $('.find-your-internet-section .owl-item .inner-content h3').matchHeight({
  //   //     byRow: false
  //   // });
  //   // $('.find-your-internet-section .owl-item .inner-content h4').matchHeight({
  //   //     byRow: false
  //   // });
  // });
  // fyis.owlCarousel({
  //   loop: true,
  //   margin: 20,
  //   dotsContainer: ".pagination-from-your-mates",
  //   navContainer: ".navigation-from-yout-mates",
  //   nav: true,
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //     1024: {
  //       items: 3,
  //     },
  //   },
  // });
  // fyis.on("changed.owl.carousel", function (event) {
  // $('.find-your-internet-section .owl-item .inner-content h3').matchHeight({
  //     byRow: false
  // });
  // $('.find-your-internet-section .owl-item .inner-content h4').matchHeight({
  //     byRow: false
  // });
  // });

  // Testimonial Slider
  const $testi_slider = $(".testimonial .owl-carousel");
  $testi_slider.owlCarousel({
    loop: true,
    autoplay: false,
    autoplayTimeout: 3000,
    autoHeight: true,
    center: true,
    margin: 0,
    navText: [
      '<button class="btn prev" title="Previous Slide"><i class="fal fa-chevron-left"></i></button>',
      '<button class="btn next" title="Next Slide"><i class="fal fa-chevron-right"></i></button>',
    ],
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        dots: true,
        nav: false,
        autoWidth: false,
      },
      1024: {
        items: 3,
        dots: false,
        nav: true,
        autoWidth: true,
      },
    },
  });

  // FEATURED BLOG SLIDER
  const featured_blog_slider = $(".nmate-blog .featured-blog-posts .owl-carousel");
  // CHECK IF THE SLIDER EXISTS
  if (featured_blog_slider.length) {
    featured_blog_slider.owlCarousel({
      loop: false,
      autoplay: true,
      autoplayTimeout: 8000,
      // autoHeight: true,
      // center: true,
      margin: 10,
      // dots: true,
      nav: true,
      items: 1,
      navText: [
        '<button class="btn prev" title="Previous Slide"><i class="fal fa-chevron-left"></i></button>',
        '<button class="btn next" title="Next Slide"><i class="fal fa-chevron-right"></i></button>',
      ],
      autoplayHoverPause: true,
    });
  }

  // FEATURED CATGEORIES
  const featured_categories_slider = $(".nmate-blog .featured-categories .owl-carousel");
  // CHECK IF THE SLIDER EXISTS
  if (featured_categories_slider.length) {
    // LOOP AND INIT THE SLIDER
    featured_categories_slider.owlCarousel({
      loop: false,
      autoplay: true,
      autoplayTimeout: 8000,
      // autoHeight: true,
      // center: true,
      margin: 18,
      // dots: true,
      nav: true,
      // items: 1,
      navText: [
        '<button class="btn prev" title="Previous Slide"><i class="fal fa-chevron-left"></i></button>',
        '<button class="btn next" title="Next Slide"><i class="fal fa-chevron-right"></i></button>',
      ],
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1024: {
          items: 3,
        },
      },
    });
  }

  // Modem SLider
  const $modem_slider = $(".modem-slider .owl-carousel");
  $modem_slider.owlCarousel({
    animateOut: "fadeOut",
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoHeight: true,
    center: true,
    margin: 0,
    navText: [
      '<a href="javascript:void(0);" class="prev" title="Previous Slide"><i class="fal fa-chevron-left"></i></a>',
      '<a href="javascript:void(0);" class="next" title="Next Slide"><i class="fal fa-chevron-right"></i></a>',
    ],
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 1,
        dots: false,
        nav: false,
        autoWidth: false,
      },
    },
  });

  // HOME BANNER SLIDER
  $(".home .mobile-banner").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    dots: false,
    adaptiveHeight: true,
    arrows: false,
    fade: true,
    refresh: true,
  });

  $(".desktop-banner").slick({
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    dots: false,
    adaptiveHeight: false,
    arrows: false,
    fade: true,
    refresh: true,
  });

  /** Services
   * ===================================== */
  $(".toggle-manual").on("click", function () {
    // Open the address not found modal
    const addressNotFoundModal = document.getElementById("addressNotFoundModal");

    if (!addressNotFoundModal) {
      return;
    }

    const modal = new bootstrap.Modal(addressNotFoundModal);
    modal.show();
  });

  $("body").on("click", ".plans .plan .mobile-head", function () {
    const $this = $(this);
    const contents = $this.parent().find(".contents");

    if ($this.hasClass("active")) {
      $this.removeClass("active");
      contents.slideUp();
    } else {
      $this.addClass("active");
      contents.slideDown();
    }
  });

  // LOAD MORE POSTS
  $(".load-more-posts").on("click", function (e) {
    e.preventDefault();
    // GET DATA
    var $this = $(this);
    var wp_ajax = $("body").data("wp-ajax-url");
    var page = $(this).data("page");
    var excluded_posts = $(this).data("excluded-posts");
    var posts_per_page = $(this).data("posts-per-page");
    //
    $.ajax({
      url: wp_ajax,
      type: "POST",
      dataType: "json",
      data: {
        action: "nload_more_posts",
        page: page,
        excluded_posts: excluded_posts,
        posts_per_page: posts_per_page,
      },
      beforeSend: function () {
        // ADD DISABLED CLASS
        $this.addClass("disabled");
      },
      success: function (response) {
        if(response.status != "empty"){
          // UPDATE PAGE
          $this.data("page", response.page);
          // INSERT CONTENT more-posts-wrapper
          $(".more-posts-wrapper").append(response.content);
          // REMOVE DISABLED CLASS
          $this.removeClass("disabled");
        } else {
          $this.remove();
        }
      },
    });

    console.log(wp_ajax, page, excluded_posts, posts_per_page);
  });
  $(".load-more-post").on("click", function () {
    let $this = $(this);
    let wp_ajax = $("body").data("wp-ajax-url");
    let has_cat = $this.data("cat") ? $this.data("cat") : "";
    let has_post_type = $this.data("post-type") ? $this.data("post-type") : "";
    let has_taxonomy = $this.data("taxonomy") ? $this.data("taxonomy") : "";
    let has_term = $this.data("term") ? $this.data("term") : "";
    let exclude_pids = $(this).attr("data-pids");
    let content = $(".posts");

    if (!$this.hasClass("disabled")) {
      $this.addClass("disabled");
      $this.text("loading...");
      /** Get The Courses AJAX
       * ===================================== */
      $.ajax({
        url: wp_ajax,
        type: "POST",
        data: {
          action: "load_more_posts",
          exclude_pids: exclude_pids,
          has_cat: has_cat,
          has_post_type: has_post_type,
          has_taxonomy: has_taxonomy,
          has_term: has_term,
        },
        success: function (response) {
          var res = JSON.parse(response);
          content.append(res.content);
          $this.attr("data-pids", res.pids);
          $this.text("load more");
          $this.removeClass("disabled");
          if (res.total_result < 9) {
            $this.remove();
            setTimeout(function () {
              content.find(".post.end").slideUp(600);
            }, 3000);
          }
        },
      });
    }
  });
});
